import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { GlowButton, GlassCard, SectionShell } from './LandingPrimitives';

const VisionSection = ({ onTalkToUs }) => {
  return (
    <SectionShell id="vision" eyebrow="Future AI Vision" title="Help us build what comes next" className="pb-10 md:pb-14">
      <GlassCard className="border border-ga-primary/30">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <div>
            <div className="mb-4 inline-flex items-center rounded-full border border-ga-primary/40 bg-ga-primary-soft px-3 py-1 text-xs font-semibold text-ga-primary">
              <Sparkles className="mr-2 h-3 w-3" />
              Future Intelligence
            </div>
            <ul className="space-y-3 text-sm text-ga-text-muted">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-ga-primary/70" />
                Demand forecasting for peak hours and seasons
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-ga-primary/70" />
                Staff behaviour analytics for reliability and efficiency
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-ga-primary/70" />
                Revenue optimization based on slot-level demand patterns
              </li>
            </ul>
          </div>
          <div className="shrink-0">
            <GlowButton as={Link} to="/contact" variant="ghost" onClick={onTalkToUs}>
              <Sparkles className="mr-2 h-4 w-4" />
              Talk to us
            </GlowButton>
          </div>
        </div>
      </GlassCard>
    </SectionShell>
  );
};

export default VisionSection;
